import React from 'react'

const EditorConfigContext = React.createContext()

export function EditorConfigProvider({ config, ...props }) {
    return <EditorConfigContext.Provider value={config} {...props} />
}

export function useEditorConfig() {
    const context = React.useContext(EditorConfigContext)

    if (context === undefined) {
        throw new Error('useConfig must be used with EditorConfigProvider')
    }

    return context
}

export default EditorConfigContext
